(function () {
if (window.HTHome) { window.HTHome.initAll(document); return; }
var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
var hasIO = 'IntersectionObserver' in window;
var CHECK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 6 9 17l-5-5"/></svg>';
function qa(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
function pad(n) { return (n < 10 ? '0' : '') + n; }
function initAnn(el) {
if (el._ht) { return; } el._ht = true;
var msgs = qa('.ht-ann__msg', el);
if (msgs.length < 2) { return; }
var i = 0;
setInterval(function () {
if (window.innerWidth > 700) { return; }
msgs[i].classList.remove('is-on');
i = (i + 1) % msgs.length;
msgs[i].classList.add('is-on');
}, 3800);
}
function initHero(el) {
if (el._ht) { return; } el._ht = true;
var slides = qa('.ht-slide', el);
var dots = qa('.ht-dot', el);
if (!slides.length) { return; }
var idx = 0, timer = null, paused = false;
var dur = parseInt(el.getAttribute('data-duration') || '6', 10) * 1000;
el.style.setProperty('--ht-dur', (dur / 1000) + 's');
function show(n) {
idx = (n + slides.length) % slides.length;
slides.forEach(function (s, k) { s.classList.toggle('is-active', k === idx); s.setAttribute('aria-hidden', k === idx ? 'false' : 'true'); });
dots.forEach(function (d, k) {
d.classList.remove('is-active'); void d.offsetWidth;
d.classList.toggle('is-active', k === idx);
d.setAttribute('aria-current', k === idx ? 'true' : 'false');
});
el.classList.toggle('is-light-active', slides[idx].classList.contains('ht-slide--light'));
schedule();
}
function schedule() {
clearTimeout(timer);
if (paused || reduce || slides.length < 2) { return; }
timer = setTimeout(function () { show(idx + 1); }, dur);
}
dots.forEach(function (d, k) { d.addEventListener('click', function () { show(k); }); });
var prev = el.querySelector('[data-ht-prev]'), next = el.querySelector('[data-ht-next]');
if (prev) { prev.addEventListener('click', function () { show(idx - 1); }); }
if (next) { next.addEventListener('click', function () { show(idx + 1); }); }
el.addEventListener('mouseenter', function () { paused = true; el.classList.add('is-paused'); clearTimeout(timer); });
el.addEventListener('mouseleave', function () { paused = false; el.classList.remove('is-paused'); schedule(); });
var x0 = null;
el.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
el.addEventListener('touchend', function (e) {
if (x0 === null) { return; }
var dx = e.changedTouches[0].clientX - x0; x0 = null;
if (Math.abs(dx) > 45) { show(idx + (dx < 0 ? 1 : -1)); }
});
document.addEventListener('visibilitychange', function () { if (document.hidden) { clearTimeout(timer); } else { schedule(); } });
el.addEventListener('shopify:block:select', function (e) {
var k = slides.indexOf(e.target.closest('.ht-slide'));
if (k > -1) { paused = true; show(k); }
});
show(0);
}
function initRail(el) {
if (el._ht) { return; } el._ht = true;
var track = el.querySelector('[data-ht-track]');
if (!track) { return; }
function step() { var c = track.querySelector('.ht-card'); return c ? c.getBoundingClientRect().width + 18 : 300; }
var p = el.querySelector('[data-ht-left]'), n = el.querySelector('[data-ht-right]');
if (p) { p.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); }); }
if (n) { n.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); }); }
}
function initCount(el) {
if (el._ht) { return; } el._ht = true;
var fixed = el.getAttribute('data-end');
function target() {
if (fixed) { var t = Date.parse(fixed); if (!isNaN(t)) { return t; } }
var d = new Date();
var add = (7 - d.getDay()) % 7;
var end = new Date(d.getFullYear(), d.getMonth(), d.getDate() + add, 23, 59, 59);
return end.getTime();
}
var u = { d: el.querySelector('[data-u=d]'), h: el.querySelector('[data-u=h]'), m: el.querySelector('[data-u=m]'), s: el.querySelector('[data-u=s]') };
function tick() {
var diff = Math.max(0, Math.floor((target() - Date.now()) / 1000));
if (u.d) { u.d.textContent = Math.floor(diff / 86400); }
if (u.h) { u.h.textContent = pad(Math.floor(diff % 86400 / 3600)); }
if (u.m) { u.m.textContent = pad(Math.floor(diff % 3600 / 60)); }
if (u.s) { u.s.textContent = pad(diff % 60); }
}
tick(); setInterval(tick, 1000);
}
function countUp(el) {
var end = parseFloat(el.getAttribute('data-count'));
if (isNaN(end) || reduce) { return; }
var pre = el.getAttribute('data-pre') || '', suf = el.getAttribute('data-suf') || '';
var t0 = null;
function stepFn(now) {
if (t0 === null) { t0 = now; }
var p = Math.min(1, (now - t0) / 1400);
el.textContent = pre + Math.round(end * (1 - Math.pow(1 - p, 3))) + suf;
if (p < 1) { requestAnimationFrame(stepFn); }
}
requestAnimationFrame(stepFn);
}
var io = hasIO ? new IntersectionObserver(function (entries) {
entries.forEach(function (e) {
if (!e.isIntersecting) { return; }
e.target.classList.add('is-in');
qa('[data-count]', e.target).forEach(countUp);
io.unobserve(e.target);
});
}, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }) : null;
function initReveal(el) {
if (el._ht) { return; } el._ht = true;
if (io) { io.observe(el); } else { el.classList.add('is-in'); }
}
var toast;
function showToast(msg) {
if (!toast) {
toast = document.createElement('div');
toast.className = 'ht-toast';
toast.setAttribute('role', 'status');
document.body.appendChild(toast);
}
toast.innerHTML = CHECK + '<span>' + msg + '</span><a href="' + root + 'cart">Ver carrito</a>';
toast.classList.add('is-show');
clearTimeout(toast._t);
toast._t = setTimeout(function () { toast.classList.remove('is-show'); }, 4200);
}
function addToCart(btn) {
var id = btn.getAttribute('data-ht-add');
if (!id) { return; }
var label = btn.innerHTML;
btn.classList.add('is-busy');
fetch(root + 'cart/add.js', {
method: 'POST',
headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
body: JSON.stringify({ items: [{ id: parseInt(id, 10), quantity: 1 }] })
}).then(function (r) {
if (!r.ok) { return r.json().then(function (j) { throw new Error(j.description || j.message || 'Error'); }); }
return fetch(root + 'cart.js', { headers: { 'Accept': 'application/json' } });
}).then(function (r) { return r.json(); }).then(function (cart) {
var ev = new CustomEvent('cart:update', { bubbles: true, detail: { resource: cart, sourceId: 'ht-home', data: { itemCount: cart.item_count, source: 'ht-home' } } });
document.dispatchEvent(ev);
btn.classList.remove('is-busy');
btn.classList.add('is-done');
btn.innerHTML = CHECK + ' Agregado';
setTimeout(function () { btn.classList.remove('is-done'); btn.innerHTML = label; }, 2200);
showToast('Producto agregado al carrito');
}).catch(function (err) {
btn.classList.remove('is-busy');
showToast(err && err.message ? err.message : 'No se pudo agregar. Intenta de nuevo.');
});
}
document.addEventListener('click', function (e) {
var btn = e.target.closest ? e.target.closest('[data-ht-add]') : null;
if (btn) { e.preventDefault(); addToCart(btn); }
});
function initNews(el) {
if (el._ht) { return; } el._ht = true;
}
function initAll(scope) {
qa('[data-ht-ann]', scope).forEach(initAnn);
qa('[data-ht-hero]', scope).forEach(initHero);
qa('[data-ht-rail]', scope).forEach(initRail);
qa('[data-ht-count]', scope).forEach(initCount);
qa('.ht-reveal', scope).forEach(initReveal);
qa('[data-ht-news]', scope).forEach(initNews);
}
window.HTHome = { initAll: initAll };
if (document.readyState === 'loading') {
document.addEventListener('DOMContentLoaded', function () { initAll(document); });
} else {
initAll(document);
}
document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
